type LogLevel = "trace" | "debug" | "info" | "warn" | "error" | "silent";

// These are used to store the selected media devices in localStorage
export const SELECTED_AUDIO_OUTPUT_KEY = "TwilioVideoApp-selectedAudioOutput";
export const DEBUG_LEVEL: LogLevel = process.env.REACT_APP_DEBUG_LEVEL as LogLevel || "silent";

export const PLAYBACKBOT_IDENTITY = "playback-bot";